import { defineNuxtPlugin } from '@nuxtjs/composition-api'

export default defineNuxtPlugin((context) => {
  context.store.commit('control-panel/clearTranslations')
  context.app.i18n.postTranslation = (translated, key) => {
    context.store.commit('control-panel/addTranslation', { translated, key })
    return translated
  }
})
